import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index.vue'
import Main from '@/components/pages/Main.vue'
import Gallery from '@/components/pages/Gallery.vue'
import Project1 from '@/components/pages/Project1.vue'
import Project2 from '@/components/pages/Project2.vue'
import Project3 from '@/components/pages/Project3.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index,
      children: [
        {
          path: '',
          component: Main,
        },
        {
          name: "project-1",
          path: 'ikea-dashboard',
          component: Project1,
        },
        {
          name: "project-2",
          path: 'second-stage',
          component: Project2,
        },
        {
          name: "project-3",
          path: 'first-prize',
          component: Project3,
        },
      ],
    },
    {
      name: 'gallery',
      path: '/gallery',
      component: Gallery,
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      const position = {}
      // New navigation.
      // scroll to anchor by returning the selector.
      if (to.hash.length) {
        position.selector = to.hash
      } else {
        position.x = 0
        position.y = 0
      }
      return position
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js